import { jwtDecode } from "jwt-decode";

export const getDistributorNames = () => {
  try {
    const userDataStr = localStorage.getItem("user");
    if (!userDataStr) return [];

    const { idToken } = JSON.parse(userDataStr);
    const decodedToken = jwtDecode(idToken);

    // `custom:distributor_name` can be a string or array depending on setup
    const distributorName = decodedToken["custom:distributor_name"];

    if (Array.isArray(distributorName)) {
      return distributorName;
    }

    if (typeof distributorName === "string") {
      // Optional: split by comma if it's a comma-separated string
      return distributorName.split(",").map((name) => name.trim());
    }

    return [];
  } catch (error) {
    console.error("Error getting distributor names:", error);
    return [];
  }
};

export const getUserId = () => {
  try {
    const userDataStr = localStorage.getItem("user");
    if (!userDataStr) return null;

    const { idToken } = JSON.parse(userDataStr);
    const decodedToken = jwtDecode(idToken);

    // Replace "sub" with the correct key if your user ID is stored under a different claim
    const userId = decodedToken["custom:UserID"] || decodedToken["sub"];

    return userId || null;
  } catch (error) {
    console.error("Error getting user ID:", error);
    return null;
  }
};

export const getUser = () => {
  try {
    const userDataStr = localStorage.getItem("user");
    if (!userDataStr) return null;

    const { idToken } = JSON.parse(userDataStr);
    const decodedToken = jwtDecode(idToken);

    return decodedToken || null;
  } catch (error) {
    console.error("Error getting user:", error);
    return null;
  }
};

/**
 * Transforms data for export using table header labels as column names
 * @param {Array} data - The raw data array
 * @param {Array} tableHeaders - Array of header objects with {label, value} structure
 * @param {Array} visibleHeaders - Array of visible header values
 * @param {Array} excludeColumns - Array of column values to exclude from export (default: ['action'])
 * @returns {Array} Transformed data with header labels as keys
 */
export const getExportData = (data, tableHeaders, visibleHeaders, excludeColumns = ['action']) => {
  // Get visible headers (excluding specified columns)
  const exportHeaders = tableHeaders.filter(header => 
    visibleHeaders.includes(header.value) && !excludeColumns.includes(header.value)
  );

  // Transform data to use header labels as keys
  const transformedData = data.map(item => {
    const exportItem = {};
    exportHeaders.forEach(header => {
      // Use the header label as the key and get the corresponding value
      exportItem[header.label] = item[header.value] || '';
    });
    return exportItem;
  });

  return transformedData;
};